import { TextField } from 'components/ui';
import { FormattedMessage, useIntl } from 'react-intl';
import Form from 'components/filter/from';
import BucketSelect from 'components/form/bucket_select';
import PlaceAutocomplete from 'components/form/autocomplete/place';

const FilterForm = ({ initialValues, defaultValues, processing, onSubmit, onClose, placeId }) => {
  const intl = useIntl();

  return (
    <Form
      header={<FormattedMessage id="header.inspection_subject.filter" />}
      processing={processing}
      onClose={onClose}
      initialValues={initialValues}
      onSubmit={onSubmit}
      defaultValues={defaultValues}
      contentRenderer={(formik) => (
        <>
          <TextField
            fullWidth
            autoFocus
            margin="dense"
            id="name"
            name="name"
            label={intl.formatMessage({ id: 'name' })}
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={(formik.touched.name && Boolean(formik.errors.name)) || undefined}
            helperText={formik.touched.name && formik.errors.name}
          />
          <TextField
            fullWidth
            margin="dense"
            id="brand"
            name="brand"
            label={intl.formatMessage({ id: 'inspection_subject.brand' })}
            value={formik.values.brand}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={(formik.touched.brand && Boolean(formik.errors.brand)) || undefined}
            helperText={formik.touched.brand && formik.errors.brand}
          />
          <TextField
            fullWidth
            margin="dense"
            id="model"
            name="model"
            label={intl.formatMessage({ id: 'inspection_subject.model' })}
            value={formik.values.model}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={(formik.touched.model && Boolean(formik.errors.model)) || undefined}
            helperText={formik.touched.model && formik.errors.model}
          />
          <TextField
            fullWidth
            margin="dense"
            id="serialNumber"
            name="serialNumber"
            label={intl.formatMessage({ id: 'inspection_subject.serial_number' })}
            value={formik.values.serialNumber}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              (formik.touched.serialNumber && Boolean(formik.errors.serialNumber)) || undefined
            }
            helperText={formik.touched.serialNumber && formik.errors.serialNumber}
          />
          <BucketSelect
            margin="dense"
            id="bucket"
            name="bucket"
            label={intl.formatMessage({ id: 'filter.bucket' })}
            value={formik.values.bucket}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={(formik.touched.bucket && Boolean(formik.errors.bucket)) || undefined}
          />
          {!placeId && (
            <PlaceAutocomplete
              margin="dense"
              id="placeId"
              name="placeId"
              label={intl.formatMessage({ id: 'place' })}
              value={formik.values.placeId}
              onChange={formik.handleChange}
              setValue={formik.setFieldValue}
              onBlur={formik.handleBlur}
              error={(formik.touched.placeId && Boolean(formik.errors.placeId)) || undefined}
              helperText={formik.touched.placeId && formik.errors.placeId}
            />
          )}
        </>
      )}
    />
  );
};

export default FilterForm;
